import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Modo bypass DESACTIVADO - Login de admin requerido
const ADMIN_BYPASS_MODE = false;

// Determina si un usuario tiene acceso SOLO a challenges (no Club VIP)
export const isChallengeOnlyUser = (user) => {
  if (!user) return false;
  if (user.role === 'admin') return false;
  const level = user.subscription_level || 'free';
  const purchased = user.purchased_challenges || [];
  // Un usuario es "solo challenge" si:
  // 1) Su nivel es explícitamente challenge_only, o
  // 2) Es free y tiene al menos un challenge comprado
  if (level === 'challenge_only') return true;
  if (level === 'free' && purchased.length > 0) return true;
  return false;
};

export const getChallengeRedirectPath = (user) => {
  const purchased = user?.purchased_challenges || [];
  if (purchased.length > 0) return `/challenge/${purchased[0]}`;
  return '/my-challenges';
};

const ProtectedRoute = ({ children, adminOnly = false, vipOnly = false }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    // Si es ruta admin y está en modo bypass, permitir acceso directo
    if (adminOnly && ADMIN_BYPASS_MODE) {
      setUser({ role: 'admin', name: 'Admin', email: 'admin@temp.com' });
      setIsAuthenticated(true);
      return;
    }

    const token = localStorage.getItem('session_token');
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    try {
      const response = await axios.get(`${BACKEND_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data);
      setIsAuthenticated(true);
    } catch (error) {
      localStorage.removeItem('session_token');
      setIsAuthenticated(false);
    }
  };

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && user && user.role !== 'admin') {
    return <Navigate to="/dashboard" />;
  }

  // Bloquear acceso al Club VIP para usuarios que solo tienen challenges
  if (vipOnly && isChallengeOnlyUser(user)) {
    return <Navigate to={getChallengeRedirectPath(user)} replace />;
  }

  return children;
};

export default ProtectedRoute;
